import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, tap, catchError, BehaviorSubject } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class NotiService {
  noti$ = new BehaviorSubject<number>(this.getNoti());
  private readonly notiKey = 'noti';
  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService,) { }

  getAdminNoti(): Observable<any> {
    return this.http.get<any>(`${apiurl}/notification`).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  getNoti(): number {
    return parseFloat(localStorage.getItem(this.notiKey)) || 0;
  }

  updateRead(data:any): Observable<any> {
    return this.http.post<any>(`${apiurl}/notification/update/read`,data).pipe(
      tap((response) => response),
      catchError((error) => this.errorHandler.handleError(error))
    );
  }

  setNoti(count:number){
    localStorage.setItem(this.notiKey,`${count}`);
    this.noti$.next(count);
  }
}
